export { default as AddPerson } from "./add-person.component";
export { default as DeletePerson } from "./delete-person.component";